import LandingComponent from "../components/landing";

export const MainLandingSection = {
  key: "component--landing",
  component: LandingComponent,
};

export const DatoKeyValuesMap = [MainLandingSection];
